import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';

export interface IHourCode extends BaseEntity {
    id: string;
    code: string;
    name: string;
    description?: string;
    twinfieldCode?: string;
    value?: number;
    value2?: string; // Gebruikt voor eenheid (bijv. "Kilometer", "Aantal dagen")
    salaryScaleGroupId: string;
    salaryScaleGroupName?: string;
    type: number; // 0 = Looncomponent, 1 = Onkosten
}

export class HourCodeService extends BaseService<IHourCode> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'hr/hourcode');
    }

    public getBySalaryScaleGroupId = (salaryScaleGroupId: string): ng.IPromise<IHourCode[]> => {
        return this.Restangular.one(this.itemName + '/group/' + salaryScaleGroupId).get().then((response: any) => {
            if (response && typeof response !== "string" && response.plain) {
                return response.plain();
            }
            return response;
        });
    }

    public getBySalaryScaleGroupIdForTimezones = (salaryScaleGroupId: string): ng.IPromise<IHourCode[]> => {
        return this.Restangular.one(this.itemName + '/group/' + salaryScaleGroupId + '/fortimezones').get().then((response: any) => {
            if (response && typeof response !== "string" && response.plain) {
                return response.plain();
            }
            return response;
        });
    }

    public getByType = (type: number): ng.IPromise<IHourCode[]> => {
        return this.Restangular.one(this.itemName + '/type/' + type).get().then((response: any) => {
            if (response && typeof response !== "string" && response.plain) {
                return response.plain();
            }
            return response;
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/services/hourCode.service.ts